/**
 * Environment variable access.
 *
 * Vite consumers inject `__IG_BUILD_ENV__` at build time. Other runtimes use
 * the `process.env` fallback. The explicit build seam keeps `import.meta` out
 * of this package, so Shopify's ES2015 extension build can parse the root
 * barrel without warning even when it later tree-shakes this module away.
 */
declare const __IG_BUILD_ENV__: Record<string, string | undefined> | undefined;

export const fromProcess = <R = string, D = undefined>(
  key: string,
  defaultValue?: string | null
): R | D => {
  const buildEnv =
    typeof __IG_BUILD_ENV__ === "undefined" ? undefined : __IG_BUILD_ENV__;
  if (buildEnv && Object.keys(buildEnv).length > 0 && buildEnv[key]) {
    return buildEnv[key] as R;
  }

  if (typeof process !== "undefined") {
    // eslint-disable-next-line n/no-process-env
    return (process.env[key] as R) ?? (defaultValue as D);
  }

  return defaultValue as D;
};
